import styled from "styled-components";

const Grid = styled.div<{ size?: string; gap?: string }>`
  display: grid;
  gap: ${({ gap = "1rem" }) => gap};
  grid-template-columns: repeat(
    auto-fill,
    minmax(${({ size = "20rem" }) => size}, 1fr)
  );
`;

export default Grid;
